import { IChatConversation } from "@/api";
import type { IChatConversationListItem } from "@/api/chat/chat.types";

/**
 * getConversationTitle returns the title of the conversation.
 * @param conversation - The conversation object
 * @returns "Untitled" if the title is empty, otherwise returns the conversation title
 */
export const getConversationTitle = (conversation: IChatConversation) => {
    // If conversation title is empty, return "Untitled"
    if (conversation.title.trim() === "") {
        return "Untitled";
    }

    return conversation.title;
};

/** Return the chat's last activity: its last message time, else its update time, as the server sorts. */
export function activityTime(
    row: Pick<IChatConversationListItem, "last_message_at" | "updated_at">
): string {
    return row.last_message_at ?? row.updated_at;
}
